import { render } from "./ocean-blocked-sheet.vue?vue&type=template&id=b2b5cca0"
import script from "./ocean-blocked-sheet.vue?vue&type=script&lang=js"
export * from "./ocean-blocked-sheet.vue?vue&type=script&lang=js"
script.render = render

export default script